import { Pipe, PipeTransform } from '@angular/core';
import { LocalizedKeyValue } from '../models/dataref.model';

@Pipe({
  name: 'translateReferenceCode',
  standalone: true,
})
export class TranslateReferenceCodePipe implements PipeTransform {
  transform(code: string, dataRefs: LocalizedKeyValue[] | null): string {
    return dataRefs?.find((dataRef) => dataRef.key === code)?.translatedName ?? code;
  }
}
